import * as types from '../actions/types';

const initialState = {
    questionaireList: [], 
    questionaireDetail:[],
    success: false
}

export default function questionaireReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.GET_QUESTIONAIRE_LIST:
            return {
                ...state,
                questionaireList: action.payload?.data,
                success: true
            };
            case types.GET_QUESTIONAIRE_DEATIL:
            return {
                ...state,
                questionaireDetail: [...state.questionaireDetail, action.payload.data.data],
                success: true
            }
        default:
            return state
    }
}